<template>
    <transition name="fade slide-down">
        <div v-show="notClosedYet && !isHidden" class="cookie-layer">
            <span v-html="text"></span>
            <button @click="close" class="cookie-layer__close is-cross">Schließen</button>
        </div>
    </transition>
</template>

<script>
const LOCAL_STORAGE_KEY = 'cookiesClosed';

export default {
    name: 'CookieLayer',
    computed: {
        notClosedYet() {
            return !localStorage.getItem(LOCAL_STORAGE_KEY);
        }
    },
    data() {
        return {
            isHidden: false,
        };
    },
    props: {
        text: {
            type: String,
            default: '',
        }
    },
    methods: {
        close() {
            this.isHidden = true;
            localStorage.setItem(LOCAL_STORAGE_KEY, 1);
        }
    }
}
</script>

<style lang="scss">

@import '../scss/config';
$close-size: size(font-regular);
$frame-size: small;
$padding: size($frame-size);

.cookie-layer {
    @include frame($frame-size);
    font-size: size(font-tiny);
    position: fixed;
    top: 0;
    z-index: 110;
    padding-right: $close-size + $padding;
    width: 100%;

    a {

        &,
        &:active,
        &:visited {
            text-decoration: underline;
        }
    }

    &__close {
         @include cross-button((
            size: $close-size,
            color: color(background),
            roundness: 0,
            thickness: 0.1,
        ));

        position: absolute;
        top: $padding;
        right: $padding;
    }
}
</style>
